import FormDisableableMixin from 'mixins/FormDisableableMixin'
import ValidationService from 'services/ValidationService'

export default {
    mixins: [FormDisableableMixin],

    props: {
        formData: { type: Object, default: undefined },
        valuePath: { type: String, default: undefined },
        label: { type: String, default: undefined },
        placeholder: { type: String, default: undefined },
        hasAutofocus: { type: Boolean, default: false },
        isRequired: { type: Boolean, default: false },
        error: { type: String, default: undefined },
        name: { type: String, default: undefined },
        prefillVal: { type: [String, Number], default: undefined },
    },

    computed: {
        prefill() {
            if ((this.formData && this.formData[this.valuePath]) || this.prefillVal) {
                return this.prefillVal ?? this.formData[this.valuePath]
            }
            return null
        },

        errorMessage() {
            if (this.formData?.errors[this.valuePath]) {
                return this.formData.errors[this.valuePath]
            } else if (ValidationService.get(this.valuePath)) {
                return ValidationService.get(this.valuePath).message
            } else if (this.error) {
                return this.error
            }
            return false
        },
    },

    methods: {
        change(event) {
            const value = event instanceof Event ? event.target.value : event

            if (value !== undefined) {
                this.emitEvent({
                    name: 'change',
                    payload: { path: this.valuePath, value },
                })
            }
        },

        clearInput() {
            this.emitEvent({
                name: 'clear',
                payload: { path: this.valuePath },
            })
        },
    },
}
